import { render, staticRenderFns } from "./storageLocationName.vue?vue&type=template&id=5af53a36"
import script from "./storageLocationName.vue?vue&type=script&lang=js"
export * from "./storageLocationName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports